import { render, staticRenderFns } from "./servicePage.vue?vue&type=template&id=56e295be&scoped=true&"
import script from "./servicePage.vue?vue&type=script&lang=js&"
export * from "./servicePage.vue?vue&type=script&lang=js&"
import style0 from "./servicePage.vue?vue&type=style&index=0&id=56e295be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e295be",
  null
  
)

export default component.exports